import { render, staticRenderFns } from "./historique-examen-clinique.html?vue&type=template&id=33771a10&scoped=true&external"
import script from "./historique-examen-clinique.js?vue&type=script&lang=js&external"
export * from "./historique-examen-clinique.js?vue&type=script&lang=js&external"
import style0 from "./historique-examen-clinique.scss?vue&type=style&index=0&id=33771a10&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33771a10",
  null
  
)

export default component.exports